import React, { useEffect, useState } from "react";
import styles from "./Onboarding.module.scss";
import SettingsStep from "./SettingsStep";
import { Button } from "src/components";
import HearAboutUs from "./HearAboutUs";
import { IoIosArrowBack } from "react-icons/io";
import Level from "./Level";
import Help from "./Help";
import { toast } from "react-hot-toast";
import Axios from "src/services/api";

const Onboarding = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [errors, setErrors] = useState<any>({});
  const [show, setShow] = useState(true);
  const [verify, setVerify] = useState(true);

  useEffect(() => {
    setShow(true);
  }, [currentStep]);

  const [userState, setUserState] = useState({
    firstName: "",
    lastName: "",
    currency: "USD",
    contactEmail: "",
    country: "US",
    zipCode: "",
    subdomain: "",
    state: "",
    city: "",
    agree: false,
    hearAboutUs: "",
    taxId: "",
    level: "newbie",
    inviteCode: "",
    creatorName: "",
  });

  const validateForm = () => {
    let formErrors: any = {};
    if (currentStep === 1) {
      if (!userState.firstName) {
        formErrors.firstName = "First name is required";
      }
      if (!userState.lastName) {
        formErrors.lastName = "Last name is required";
      }
      if (!userState.contactEmail) {
        formErrors.contactEmail = "Support email is required";
      }
      // validate contact email
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (userState.contactEmail && !emailRegex.test(userState.contactEmail)) {
        formErrors.contactEmail = "Invalid email address";
      }
      if (!userState.subdomain) {
        formErrors.subdomain = "Username is required";
      }
      // if (!userState.currency) {
      //   formErrors.currency = "Currency is required";
      // }

      if (!userState.agree) {
        formErrors.agree = "You must agree to the terms and conditions";
      }

      if (!verify) {
        formErrors.subdomain = "Pick a unique username";
      }

      if (!userState.country) {
        formErrors.country = "Country is required";
      }
      if (!userState.zipCode) {
        formErrors.zipCode = "Zip code is required";
      }
      if (!userState.state) {
        formErrors.state = "State is required";
      }
      if (!userState.city) {
        formErrors.city = "City is required";
      }
    }
    setErrors(formErrors);

    return Object.keys(formErrors).length === 0;
  };

  const checkCountryAvailability = async (
    country: string
  ): Promise<boolean> => {
    try {
      const stripeGlobalAvailability = await import(
        "src/services/stripeGlobalAvailability.json"
      );
      return stripeGlobalAvailability.default.some(
        (availableCountry: { code: string }) =>
          availableCountry.code === country
      );
    } catch (error) {
      console.error("Error loading country availability data:", error);
      return false;
    }
  };

  const onClickNext = async () => {
    if (!validateForm()) return;

    if (currentStep === 4) {
      // const isGloballySupported = await checkCountryAvailability(
      //   userState.country
      // );
      // Set isAccountApproved to true if country is in the list
      // India will have additional business approval separate from account approval
      toast.promise(
        Axios.post("/users/finish-onboarding", {
          ...userState,
          subdomain: userState.subdomain.toLowerCase(),
          isAccountApproved: false,
        }).then((res) => {
          window.location.href = "/guide";
        }),
        {
          loading: "Saving data...",
          success: "Saved!",
          error: "Error while saving.",
        }
      );
      return;
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  return (
    <div className={styles.onboardingPage}>
      <div className={styles.nav}>
        <img
          className={styles.logoImageText}
          src={process.env.PUBLIC_URL + "/pf-logo.svg"}
          alt="Pocketsflow"
        />
      </div>
      <div className={styles.pageContent}>
        <div className={styles.stepIndicator}>
          <div
            className={styles.indicator}
            style={{
              width: `${(currentStep / 4) * 100}%`,
            }}
          />
        </div>
        {currentStep > 1 && (
          <div
            className={styles.back}
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            <IoIosArrowBack size={24} />
          </div>
        )}
        {currentStep === 1 ? (
          <SettingsStep
            userState={userState}
            setUserState={setUserState}
            errors={errors}
            setVerify={setVerify}
          />
        ) : currentStep === 2 ? (
          <HearAboutUs userState={userState} setUserState={setUserState} />
        ) : currentStep === 3 ? (
          <Level userState={userState} setUserState={setUserState} />
        ) : (
          <Help userState={userState} setUserState={setUserState} />
        )}
        <div className={styles.buttonContainer}>
          <Button
            onClick={onClickNext}
            text={currentStep === 4 ? "Finish onboarding!" : "Next Step"}
          />
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
